import React from 'react'
import classes from './Button.scss'

export const Button = ({ id, type, onClick, value, style, className }) => {
  const btnClasses = [classes.button, className].join(' ')
  return (
    <input type={type || 'button'} id={id} value={value} onClick={onClick} className={btnClasses} style={style} />
  )
}

export default Button



/** WEBPACK FOOTER **
 ** ./src/components/Button.js
 **/